import { KeySet } from '@eastcoal/common/types/utilities'
import { pick } from '@eastcoal/common/utils/object'

import { useSelectAndRemove } from '../../../hooks/useSelectAndRemove'
import { useSyncNodeState } from '../../../hooks/useSyncNodeState'
import { $isAttachmentNode } from '../../../nodes/AttachmentNode'
import {
  useAttachmentCardStore,
  useAttachmentCardStoreApi
} from '../Store/hooks/useStore'
import { AttachmentCardSyncState } from '../Store/store/interface'

export const ATTACHMENT_CARD_SYNC_STATE_KEYS: KeySet<AttachmentCardSyncState>[] =
  ['ossId', 'filename', 'ossUrl', 'mimeType', 'error', 'loading']

export const AttachmentSynchorizner = () => {
  const { nodeKey, cardRef } = useAttachmentCardStore(state =>
    pick(state, ['nodeKey', 'cardRef'])
  )
  const { subscribe } = useAttachmentCardStoreApi()

  // 选中/删除节点
  useSelectAndRemove({
    nodeKey,
    containerRef: cardRef,
    allowRemove: $isAttachmentNode
  })

  // AttachmentCard => AttachmentNode 状态同步
  useSyncNodeState({
    nodeKey,
    stateKeys: ATTACHMENT_CARD_SYNC_STATE_KEYS,
    isTargetNode: $isAttachmentNode,
    subscribe
  })

  return null
}
